export enum NoteCategoryEnum {
  PRODUCT_NOTE = 1,
  ORDER_NOTE = 2,
  CANCEL_ORDER_REASON = 3,
  PRODUCT_REFUND_REASON = 4,
  CANCEL_SERVICE_REASON = 5,
  ORDER_TAG = 6,
  SHIPMENT_NOTE = 7
}
